"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var SelloutTerminationConverter_1 = require("./conversions/price-termination/SelloutTerminationConverter");

var SelloutTerminationConverterImpl_1 = require("./conversions/price-termination/SelloutTerminationConverterImpl");

var SelloutTerminationItemConverter_1 = require("./conversions/price-termination/SelloutTerminationItemConverter");

var SelloutTerminationItemConverterImpl_1 = require("./conversions/price-termination/SelloutTerminationItemConverterImpl");

var SelloutTerminationSummaryConverter_1 = require("./conversions/price-termination/SelloutTerminationSummaryConverter");

var SelloutTerminationSummaryConverterImpl_1 = require("./conversions/price-termination/SelloutTerminationSummaryConverterImpl");

var SelloutTerminationUploadConverter_1 = require("./conversions/price-termination/SelloutTerminationUploadConverter");

var SelloutTerminationUploadConverterImpl_1 = require("./conversions/price-termination/SelloutTerminationUploadConverterImpl");

var SelloutTerminationUploadedItemConverter_1 = require("./conversions/price-termination/SelloutTerminationUploadedItemConverter");

var SelloutTerminationUploadedItemConverterImpl_1 = require("./conversions/price-termination/SelloutTerminationUploadedItemConverterImpl");

var SelloutDescriptionConverter_1 = require("./conversions/SelloutDescriptionConverter");

var SelloutDescriptionConverterImpl_1 = require("./conversions/SelloutDescriptionConverterImpl");

var SelloutEndReasonConverter_1 = require("./conversions/SelloutEndReasonConverter");

var SelloutEndReasonConverterImpl_1 = require("./conversions/SelloutEndReasonConverterImpl");

var SelloutIdentificationDetailDTOConverter_1 = require("./conversions/SelloutIdentificationDetailDTOConverter");

var SelloutIdentificationDetailDTOConverterImpl_1 = require("./conversions/SelloutIdentificationDetailDTOConverterImpl");

var SelloutIdentificationDTOConverter_1 = require("./conversions/SelloutIdentificationDTOConverter");

var SelloutIdentificationDTOConverterImpl_1 = require("./conversions/SelloutIdentificationDTOConverterImpl");

var SelloutIdentificationFilterConverter_1 = require("./conversions/SelloutIdentificationFilterConverter");

var SelloutIdentificationFilterConverterImpl_1 = require("./conversions/SelloutIdentificationFilterConverterImpl");

var SelloutIdentificationOverviewConverter_1 = require("./conversions/SelloutIdentificationOverviewConverter");

var SelloutIdentificationOverviewConverterImpl_1 = require("./conversions/SelloutIdentificationOverviewConverterImpl");

var SelloutSettingsConverter_1 = require("./conversions/SelloutSettingsConverter");

var SelloutSettingsConverterImpl_1 = require("./conversions/SelloutSettingsConverterImpl");

var SelloutSubSettingsConverter_1 = require("./conversions/SelloutSubSettingsConverter");

var SelloutSubSettingsConverterImpl_1 = require("./conversions/SelloutSubSettingsConverterImpl");

var SelloutSupplyConverter_1 = require("./conversions/SelloutSupplyConverter");

var SelloutSupplyConverterImpl_1 = require("./conversions/SelloutSupplyConverterImpl");

var SelloutTypeWithItemCountsConverter_1 = require("./conversions/SelloutTypeWithItemCountsConverter");

var SelloutTypeWithItemCountsConverterImpl_1 = require("./conversions/SelloutTypeWithItemCountsConverterImpl");
/**
 * @author Jaroslav Sevcik
 */


var SelloutAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(SelloutAppModule, _AppModule_1$AppModul);

  function SelloutAppModule() {
    var _this;

    _classCallCheck(this, SelloutAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'selloutAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutAppModule, [{
    key: "configure",
    value: function configure() {
      // core sellout parts
      typescript_ioc_1.Container.bind(SelloutSupplyConverter_1.SelloutSupplyConverter).to(SelloutSupplyConverterImpl_1.SelloutSupplyConverterImpl).scope(typescript_ioc_1.Scope.Singleton); // auxiliary sellout parts

      this.configureSelloutSettingsParts();
      this.configureSelloutIdentificationReportParts();
      this.configurePriceTerminationParts();
    }
  }, {
    key: "configurePriceTerminationParts",
    value: function configurePriceTerminationParts() {
      typescript_ioc_1.Container.bind(SelloutTerminationConverter_1.SelloutTerminationConverter).to(SelloutTerminationConverterImpl_1.SelloutTerminationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutTerminationItemConverter_1.SelloutTerminationItemConverter).to(SelloutTerminationItemConverterImpl_1.SelloutTerminationItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutTerminationSummaryConverter_1.SelloutTerminationSummaryConverter).to(SelloutTerminationSummaryConverterImpl_1.SelloutTerminationSummaryConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutTerminationUploadConverter_1.SelloutTerminationUploadConverter).to(SelloutTerminationUploadConverterImpl_1.SelloutTerminationUploadConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutTerminationUploadedItemConverter_1.SelloutTerminationUploadedItemConverter).to(SelloutTerminationUploadedItemConverterImpl_1.SelloutTerminationUploadedItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutEndReasonConverter_1.SelloutEndReasonConverter).to(SelloutEndReasonConverterImpl_1.SelloutEndReasonConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
    /**
     * Configures sellout settings related parts
     */

  }, {
    key: "configureSelloutSettingsParts",
    value: function configureSelloutSettingsParts() {
      typescript_ioc_1.Container.bind(SelloutDescriptionConverter_1.SelloutDescriptionConverter).to(SelloutDescriptionConverterImpl_1.SelloutDescriptionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutSettingsConverter_1.SelloutSettingsConverter).to(SelloutSettingsConverterImpl_1.SelloutSettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutSubSettingsConverter_1.SelloutSubSettingsConverter).to(SelloutSubSettingsConverterImpl_1.SelloutSubSettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
    /**
     * Configures dependencies related to SelloutIdentificationReport
     */

  }, {
    key: "configureSelloutIdentificationReportParts",
    value: function configureSelloutIdentificationReportParts() {
      typescript_ioc_1.Container.bind(SelloutIdentificationDTOConverter_1.SelloutIdentificationDTOConverter).to(SelloutIdentificationDTOConverterImpl_1.SelloutIdentificationDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutTypeWithItemCountsConverter_1.SelloutTypeWithItemCountsConverter).to(SelloutTypeWithItemCountsConverterImpl_1.SelloutTypeWithItemCountsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutIdentificationOverviewConverter_1.SelloutIdentificationOverviewConverter).to(SelloutIdentificationOverviewConverterImpl_1.SelloutIdentificationOverviewConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutIdentificationDetailDTOConverter_1.SelloutIdentificationDetailDTOConverter).to(SelloutIdentificationDetailDTOConverterImpl_1.SelloutIdentificationDetailDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutIdentificationFilterConverter_1.SelloutIdentificationFilterConverter).to(SelloutIdentificationFilterConverterImpl_1.SelloutIdentificationFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return SelloutAppModule;
}(AppModule_1.AppModule);

exports.SelloutAppModule = SelloutAppModule;